import React, { FC, useEffect, useRef, useState } from "react";
import { useFormik } from "formik";
import {
  Autocomplete,
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import { RegionsApi } from "../../v2/api/regions_api";
import { City, Province } from "../../v2/models/regions_models";
import { User } from "../../v2/models/user";
import { AllegatiUploader } from "../Preventivo/allegati_component";
import { useConfigurationsService } from "../../v2/services/configurations_service";
import { useDialogs } from "../../v2/providers/dialogs_provider";
import { DoorConfigurationConditions } from "../../v2/models/door_configuration";
import { AmountItem, NumberItem } from "../../Screen/Preventivo/richiestav2";
import NavigateBeforeIcon from "@mui/icons-material/NavigateBefore";
import { useNavigate } from "react-router-dom";
import Loading from "../Loading/loading";
import { FormikProps } from "formik";
import { CategoryCode } from "../../v2/models/category";

export interface ConditionsFormProps {
  currentUser: User;
  quote_id: number;
  category: CategoryCode;
  applyDiscount: (values: DoorConfigurationConditions, formik: FormikProps<DoorConfigurationConditions>) => void;
  handlingSubmit: (values: DoorConfigurationConditions, formik: FormikProps<DoorConfigurationConditions>) => void;
  goBack: string;
}

export const ConditionsForm: FC<ConditionsFormProps> = ({ currentUser, quote_id,category, applyDiscount,handlingSubmit,goBack }) => {
  //GENERAL
  const [refresh, setRefresh] = useState<boolean>(false);
  const initialRetailDownPaymentValue = useRef<number>(0);
  const [loading, setLoading] = useState<boolean>(true);
  const configurationService = useConfigurationsService();
  const [isSubmit, setSubmit] = useState<boolean>(false);
  const navigate = useNavigate();
  const dialogs = useDialogs();
  // INDIRIZZO
  const [regions, setRegions] = useState<{ provinces: Province[], cities: City[] }>({ provinces: [], cities: [] });
  const findProvinciaBySigla = (sigla: string): Province|undefined => {
    if (!sigla) return undefined;
    return regions.provinces.find(p => p.sigla === sigla);
  }
  const getNomeProvincia = (): string => {
    if (!formik.values.customClientProvince) return "";
    const prov = findProvinciaBySigla(formik.values.customClientProvince);
    return prov ? prov.nome : formik.values.customClientProvince ?? "";
  }
  const getCities = async (provincia: string) => {
    try {
      console.log("provincia ATTUALE:", provincia)
      const cities = await RegionsApi.findCities(provincia);
      setRegions({ ...regions, cities });
      console.log(`Cities for province ${provincia}:`, cities);
    } catch (e: any) {
      setRegions({ ...regions, cities: [] });
    }
  }

  const getImballaggioLabel = (selected: string): String|undefined => {
    if (!selected) return "Seleziona un tipo di imballaggio";
    switch (selected) {
      case "cartone":
        return "IMBALLO DI CARTONE";
      case "legno":
        return "CASSA DI LEGNO";
      default:
        return selected;
    }
  };
  const findCityByName = (name: string): City|undefined => {
    if (!name) return undefined;

    let city = regions.cities.find(c => c.nome.toLowerCase() === name.toLowerCase());
    if (city) return city;

    return {
      nome: name,
      capList: "[]",
    };
  }
  //TARSPORTO
  const isRegioneSardegna = (): boolean => {
    if (!formik.values.customClientProvince) return false;
    let prov = findProvinciaBySigla(formik.values.customClientProvince);
    return prov?.regione.toLowerCase() == "sardegna";
  }
  const isTransportAPreventivo = (): boolean => {
    return isRegioneSardegna() || (category == CategoryCode.PortaOverbas && formik.values.customClientCountry === "Estero");
  }
  const getTransportLabel = () => {
    if (isTransportAPreventivo()) return "ESCLUSO (A PREVENTIVO)";
    return formik.values.retailTransport === "include" ? "INCLUSO" : "ESCLUSO";
  };
  //MAIN
  const loadConditions = async () => {
    try {
      const provinces = await RegionsApi.getProvinces();
      setRegions({ ...regions, provinces });
      const [conditions] = await Promise.all([
        configurationService.getCondizioni(currentUser, quote_id)
      ]);
            
      if (!conditions) throw "invalid conditions";
      
      if (!conditions.customClientCountry) conditions.customClientCountry = "Italia";
      initialRetailDownPaymentValue.current = conditions.retailDownPaymentValue ?? 0;
      formik.setValues(conditions);

      setLoading(false);
    } catch (e: any) {
      setLoading(false);

      if (typeof e == "string") {
        dialogs?.showError("Attenzione...", e);
      } else {
        if (e.severity == "error") {
          dialogs?.showError("Attenzione...", e.message);
        } else if (e.severity == "warning") {
          dialogs?.showWarning("Attenzione...", e.message);
        }
      }
    }
  }
  //
  useEffect(() => {
    loadConditions();
  }, []); 
  const formik = useFormik<DoorConfigurationConditions>({
    initialValues: {
      customerId: undefined,
      customClientName: "",
      customClientAddress: "",
      customClientZipCode: "",
      customClientCity: "",
      customClientProvince: "",
      customClientCountry: "Italia",
      endClientTaxRate: 0,
      endClientDownPaymentValue: 0,
      endClientDownPaymentType: "percentage",
      endClientDiscount1: 0,
      endClientDiscount2: 0,
      endClientNet: 0,
      endClientTaxableAmount: 0,
      endClientTotalTaxes: 0,
      endClientTotalDiscount: 0,
      endClientTotal: 0,
      retailTaxRate: 0,
      retailDownPaymentType: "percentage",
      retailDownPaymentValue: 0,
      retailDiscount1: 0,
      retailDiscount2: 0,
      retailNet: 0,
      retailTaxableAmount: 0,
      retailTotalTaxes: 0,
      retailTotalDiscount: 0,
      retailTotal: 0,
      retailInstallation: "exclude",
      retailInstallationCosts: 0,
      retailTransport: "exclude",
      baseNetPrice: 0,
      totalServices: 0,
      quantity: 0,
      notes: undefined,
      isServiceCustomer: true,
      packagingType : "legno"
    },
    onSubmit: (values) => {
    },
  });
  const BuildEditFormDatiCliente = () => {
    return(<>
      <h6 className="mt-4 mb-0"><strong>Dati cliente</strong></h6>
          <div className="row">
            <div className="col-12 mt-3">
              <TextField
                fullWidth
                label="Denominazione cliente*"
                variant="outlined"
                value={formik.values.customClientName}
                onChange={(e) => formik.setFieldValue("customClientName", e.target.value)}
                error={!formik.values.customClientName}
                helperText={!formik.values.customClientName && "Campo obbligatorio"}
              />
            </div>
            <div className="col-12 mt-3">
              <TextField
                fullWidth
                label="Indirizzo"
                variant="outlined"
                value={formik.values.customClientAddress}
                onChange={(e) => formik.setFieldValue("customClientAddress", e.target.value)}
              />
            </div>
            <div className="row">
              <div className="col-xl-2 mt-3">
                <FormControl fullWidth>
                  <InputLabel>Nazione</InputLabel>
                  <Select
                    value={formik.values.customClientCountry}
                    label="Nazione"
                    onChange={(e) => {
                      formik.setValues({
                        ...formik.values,
                        customClientCountry: (e.target.value ?? "").charAt(0).toUpperCase() + (e.target.value ?? "").slice(1).toLowerCase(),
                        customClientProvince: "",
                        customClientCity: "",
                        customClientZipCode: ""
                      });
                    }}>
                    <MenuItem value="Italia">Italia</MenuItem>
                    <MenuItem value="Estero">Estero</MenuItem>
                  </Select>
                </FormControl>
              </div>
              {formik.values.customClientCountry === "Italia" && (<>
                <div className="col-xl-4 mt-3">
                    <Autocomplete
                      options={regions.provinces || []}
                      getOptionLabel={(option) => option?.nome ?? ""}
                      value={findProvinciaBySigla(formik.values.customClientProvince ?? "") || null}
                      inputValue={getNomeProvincia() ?? ""}
                      onChange={(event, newValue) => {
                        if (newValue) {
                          formik.setValues({
                            ...formik.values,
                            customClientProvince: newValue.sigla,
                            customClientCity: "",
                            customClientZipCode: ""
                          });
                          getCities(newValue.sigla);
                        } else {
                          formik.setValues({
                            ...formik.values,
                            customClientProvince: "",
                            customClientCity: "",
                            customClientZipCode: "",
                          });
      
                          setRegions({ ...regions, cities: [] });
                        }
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Provincia"
                          error={formik.errors.customClientProvince ? true : false}
                          helperText={
                            formik.errors.customClientProvince ? "Campo obbligatorio" : ""
                          }
                        />
                      )}
                      onInputChange={(event, newInputValue, reason) => {
                        if (reason == 'clear') {
                          formik.setValues({
                            ...formik.values,
                            customClientProvince: "",
                            customClientCity: "",
                            customClientZipCode: "",
                          });
                          setRegions({ ...regions, cities: [] });
                        } else if (reason == "input") {
                          formik.setValues({
                            ...formik.values,
                            customClientProvince: newInputValue,
                            customClientCity: "",
                            customClientZipCode: "",
                          });
                          setRegions({ ...regions, cities: [] });
                        }
                      }}
                    />
                </div>
                <div className="col-xl-4 mt-3">
                  <Autocomplete
                    options={regions.cities || []}
                    getOptionLabel={(option) => option?.nome ?? ""}
                    value={findCityByName(formik.values.customClientCity ?? "") || null}
                    inputValue={formik.values.customClientCity ?? ""}
                    onChange={(event, newValue) => {
                      if (newValue) {
                        const capList = JSON.parse(newValue.capList);
    
                        formik.setValues({
                          ...formik.values,
                          customClientCity: newValue.nome,
                          customClientZipCode: capList.length > 0 ? capList[0] : ""
                        });
                      } else {
                        formik.setValues({
                          ...formik.values,
                          customClientCity: "",
                          customClientZipCode: ""
                        });
                      }
                    }}
                    onInputChange={(event, newInputValue, reason) => {
                      if (reason == 'clear') {
                        formik.setValues({
                          ...formik.values,
                          customClientCity: "",
                          customClientZipCode: ""
                        });
    
                        if (regions.cities.length <= 0) {
                          getCities(formik.values.customClientProvince ?? "");
                        }
                      } else if (reason == "input") {
                        formik.setValues({
                          ...formik.values,
                          customClientCity: newInputValue,
                          customClientZipCode: "",
                        });
                      }
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Città"
                        fullWidth
                        error={formik.errors.customClientCity ? true : false}
                        helperText={formik.errors.customClientCity && "Campo obbligatorio"}
                      />
                    )}
                  />
                </div>
                <div className="col-xl-2 mt-3">
                  <TextField
                    fullWidth
                    label="C.A.P."
                    variant="outlined"
                    value={formik.values.customClientZipCode ?? ""}
                    onChange={(e) => formik.setFieldValue("customClientZipCode", e.target.value)}
                  />
                </div>
              </>)}
              {formik.values.customClientCountry === "Estero" && (<>
                <div className="col-xl-4 mt-3">
                  <TextField
                    fullWidth
                    label="Provincia"
                    variant="outlined"
                    value={formik.values.customClientProvince ?? ""}
                    onChange={(e) => formik.setFieldValue("customClientProvince", e.target.value)}
                  />
                </div>
                <div className="col-xl-4 mt-3">
                  <TextField
                    fullWidth
                    label="Città"
                    variant="outlined"
                    value={formik.values.customClientCity ?? ""}
                    onChange={(e) => formik.setFieldValue("customClientCity", e.target.value)}
                  />
                </div>
                <div className="col-xl-2 mt-3">
                  <TextField
                    fullWidth
                    label="C.A.P."
                    variant="outlined"
                    value={formik.values.customClientZipCode ?? ""}
                    onChange={(e) => formik.setFieldValue("customClientZipCode", e.target.value)}
                  />
                </div>
              </>)}
            </div>
          </div></>
    )
  }
  const BuildEditFormCondiction = (isReadOnly: boolean) => {
    return(<>
    <h6 className="mt-4 mb-0"><strong>Condizioni</strong></h6>
    <div className="row">
      <div className="col-xl-3 mt-3">
        <FormControl fullWidth>
          <InputLabel id="retailTaxRate">Aliquota IVA</InputLabel>
          <Select
            labelId="retailTaxRate"
            value={formik.values.retailTaxRate}
            label="Aliquota IVA"
            inputProps={{
              readOnly: isReadOnly
            }}
            onChange={(e) => {
              formik.setFieldValue("retailTaxRate", e.target.value);
            }}>
            <MenuItem value={0}>0</MenuItem>
            <MenuItem value={4}>4</MenuItem>
            <MenuItem value={10}>10</MenuItem>
            <MenuItem value={22}>22</MenuItem>
          </Select>
        </FormControl>
      </div>
      <div className="col-xl-3 mt-3">
        <FormControl fullWidth>
          <InputLabel id="retailDownPaymentType">Tipo di acconto</InputLabel>
          <Select
            labelId="retailDownPaymentType"
            value={formik.values.retailDownPaymentType}
            label="Tipo di acconto"
            onChange={(e) => {
              formik.setFieldValue("retailDownPaymentType", e.target.value);
            }}>
            <MenuItem value={"percentage"}>Percentuale</MenuItem>
            <MenuItem value={"amount"}>Importo</MenuItem>
          </Select>
        </FormControl>
      </div>
      <div className="col-xl-3 mt-3">
        <TextField
          label="Acconto"
          variant="outlined"
          type="number"
          value={formik.values.retailDownPaymentValue}
          onChange={(e) => {
            const value = e.target.value;
            const maxValuePecentuale = 100;
            const maxValueImport = formik.values?.retailTotal ?? 5000;
            if (formik.values.retailDownPaymentType === 'percentage') {
              if (parseFloat(value) > maxValuePecentuale) {
                dialogs?.showError("ERRORE!", "Acconto maggiore del 100%");
                formik.setFieldValue("retailDownPaymentValue", 100);
              } else {
                formik.setFieldValue("retailDownPaymentValue", value);
              }
            } else if (formik.values.retailDownPaymentType === 'amount') {
              if (parseFloat(value) > maxValueImport) {
                dialogs?.showError("ERRORE!", "Acconto maggiore del totale: " + maxValueImport);
                formik.setFieldValue("retailDownPaymentValue", maxValueImport);
              } else {
                formik.setFieldValue("retailDownPaymentValue", value);
              }
            }
          }}
          onBlur={(e) => {
            const value = parseFloat(e.target.value);
            const minValuePecentuale = initialRetailDownPaymentValue.current;
            if (formik.values.retailDownPaymentType === 'percentage' && value < minValuePecentuale) {
              dialogs?.showError("ERRORE!", "Acconto minore di " + minValuePecentuale);
              formik.setFieldValue("retailDownPaymentValue", minValuePecentuale);
            }
          }}
        />
      </div>
    </div>

    <div className="row">
      <div className="col-xl-3 mt-3">
        <TextField
          fullWidth
          label="Sconto 1"
          variant="outlined"
          type="number"
          value={formik.values.retailDiscount1}
          onChange={(e) => formik.setFieldValue("retailDiscount1", e.target.value)}
        />
      </div>

      <div className="col-xl-3 mt-3">
        <TextField
          fullWidth
          label="Sconto 2"
          variant="outlined"
          type="number"
          value={formik.values.retailDiscount2}
          disabled={Number(formik.values.retailDiscount1) === 0}
          onChange={(e) => formik.setFieldValue("retailDiscount2", e.target.value)}
        />
      </div>
    </div>
    </>)
  }
  const BuildEditFormServiceCustomer = () => {
    return(<>
      {BuildEditFormDatiCliente()}
      {BuildEditFormCondiction(false)}
    </>)
  }
  const buildEditFormRivendita = () => {
    return(<>
      {BuildEditFormDatiCliente()}
      {BuildEditFormCondiction(true)}
    </>)
  }
  const buildEditFormClienteFinale = () => {
      return (
        <>
          {BuildEditFormDatiCliente()}
          <h6 className="mt-4 mb-0"><strong>Condizioni</strong></h6>
          <div className="row">
            <div className="col-xl-3 mt-3">
              <FormControl fullWidth>
                <InputLabel id="endClientTaxRate">Aliquota IVA</InputLabel>
                <Select
                  labelId="endClientTaxRate"
                  value={formik.values.endClientTaxRate}
                  label="Aliquota IVA"
                  onChange={(e) => {
                    formik.setFieldValue("endClientTaxRate", e.target.value);
                  }}>
                  <MenuItem value={0}>0</MenuItem>
                  <MenuItem value={4}>4</MenuItem>
                  <MenuItem value={10}>10</MenuItem>
                  <MenuItem value={22}>22</MenuItem>
                </Select>
              </FormControl>
            </div>
  
            <div className="col-xl-3 mt-3">
              <FormControl fullWidth>
                <InputLabel id="endClientDownPaymentType">Tipo di acconto</InputLabel>
                <Select
                  labelId="endClientDownPaymentType"
                  value={formik.values.endClientDownPaymentType}
                  label="Tipo di acconto"
                  onChange={(e) => {
                    formik.setFieldValue("endClientDownPaymentType", e.target.value);
                  }}>
                  <MenuItem value={"percentage"}>Percentuale</MenuItem>
                  <MenuItem value={"amount"}>Importo</MenuItem>
                </Select>
              </FormControl>
            </div>
  
            <div className="col-xl-3 mt-3">
              <TextField
                fullWidth
                label="Acconto"
                variant="outlined"
                type="number"
                value={formik.values.endClientDownPaymentValue}
                onChange={(e) => formik.setFieldValue("endClientDownPaymentValue", e.target.value)}
                InputProps={{
                  inputProps: {
                    max: 100,
                    min: 0 
                  },
                }}
              />
            </div>
          </div>
  
          <div className="row">
            <div className="col-xl-3 mt-3">
              <TextField
                fullWidth
                label="Sconto"
                variant="outlined"
                type="number"
                value={formik.values.endClientDiscount1}
                onChange={(e) => formik.setFieldValue("endClientDiscount1", e.target.value)}
              />
            </div>
  
            <div className="col-xl-3 mt-3">
              <TextField
                fullWidth
                label=""
                variant="outlined"
                type="number"
                value={formik.values.endClientDiscount2}
                onChange={(e) => formik.setFieldValue("endClientDiscount2", e.target.value)}
              />
            </div>
          </div>
  
          {/*"END_CLIENT_DISCOUNT_ERROR" == data.discountError && (
            <div className="row mt-3">
              <div className="col-12">
                <Alert className="mt-2" severity="error" onClose={() => setDiscountError(false)}>Sconto non applicabile</Alert>
              </div>
            </div>
          )*/}
        </>
      );
  }
  return (<>
    <div className="container h-full">
      <div className="row m-0 h-full">
        <div className="col-xl-8 p-0 custom-scroll-richiesta">
          <div className="p-4">
            <h5 className="text-primary mb-3">
              Condizioni di vendita
              {process.env.NODE_ENV !== "production" && currentUser.isCustomer && <label>- Cliente finale</label>}
              {process.env.NODE_ENV !== "production" && !currentUser.isCustomer && <label>- Rivendita</label>}
            </h5>
            {!currentUser.isCustomer && (<>
              <div>
                {formik.values.isServiceCustomer ? BuildEditFormServiceCustomer() : null}
                {!formik.values.isServiceCustomer && buildEditFormRivendita()}
              </div>
            </>)}
            {currentUser.isCustomer && (
              <div>
                {buildEditFormClienteFinale()}
                {process.env.NODE_ENV !== "production" && <hr />}
              </div>
            )}
            <h6 className="mt-4 mb-1"><strong>Installazione</strong></h6>
            <div className="row">
              <div className="col-xl-12">
                <FormControl fullWidth>
                  <Select
                    labelId="retailInstallation"
                    value={formik.values.retailInstallation}
                    onChange={(e) => {
                      formik.setFieldValue("retailInstallation", e.target.value);
                    }}>
                    <MenuItem value={"exclude"}>ESCLUSA</MenuItem>
                    <MenuItem value={"include"}>INCLUSA</MenuItem>
                  </Select>
                </FormControl>
              </div>
            </div>
            <h6 className="mt-4 mb-1"><strong>Trasporto</strong></h6>
            <div className="row">
              <div className="col-xl-12">
                <FormControl fullWidth>
                  <Select
                    labelId="retailTransport"
                    value={formik.values.retailTransport}
                    disabled={isTransportAPreventivo()}
                    onChange={(e) => {
                      formik.setFieldValue("retailTransport", e.target.value);
                    }}
                    displayEmpty
                    renderValue={getTransportLabel}
                  >
                    <MenuItem value="exclude">ESCLUSO</MenuItem>
                    <MenuItem value="include">INCLUSO</MenuItem>
                  </Select>
                </FormControl>
              </div>
            </div>
            {(formik.values.retailTransport === "exclude" && formik.values.customClientCountry === "Estero" && (category == CategoryCode.PortaOverlap)) &&(<>
              <h6 className="mt-4 mb-1"><strong>Tipo imballaggio</strong></h6>
              <div className="row">
                <div className="col-xl-12">
                  <FormControl fullWidth>
                    <Select
                      labelId="imballaggio"
                      value={formik.values.packagingType || ""}
                      onChange={(e) => {
                        formik.setFieldValue("packagingType", e.target.value);
                      }}
                      displayEmpty
                      renderValue={getImballaggioLabel}
                    >
                      <MenuItem value="cartone">IMBALLO DI CARTONE</MenuItem>
                      <MenuItem value="legno">CASSA DI LEGNO</MenuItem>
                    </Select>
                  </FormControl>
                </div>
              </div></>)
            }
            <h6 className="mt-4 mb-0"><strong>Note aggiuntive</strong></h6>
            <TextField
              label=""
              variant="outlined"
              className="mt-2 w-full"
              type="text"
              multiline
              value={formik.values.notes}
              onChange={(e) => formik.setFieldValue("notes", e.target.value)}
            />
            {quote_id &&
              <AllegatiUploader
                currentUser={currentUser}
                quote_id={quote_id}
              />
            }
            <div className="row flex-row-reverse mt-3">
              <div className="col-xl-3 text-end">
                <Button disabled={refresh} variant="outlined" onClick={() => applyDiscount(formik.values,formik)}>AGGIORNA IMPORTI</Button>
              </div>
            </div>
          </div>
        </div>
      
        <div className="col-xl-4 p-0" style={{ overflowY: "auto", height: "100%", borderLeft: "solid 1px #ccc", position: "relative" }}>
              <div className="p-4">
              <h5 className="text-primary">Totali</h5>
              <div className="mt-1 rounded-3 p-3 bg-light " style={{ position: "relative" }}>
                <div className="d-flex justify-content-between">
                  <NumberItem label="Quantità:" value={formik.values.quantity} />
                </div>

                <div className="d-flex justify-content-between">
                  <AmountItem label="Totale merce:" value={formik.values.baseNetPrice} />
                </div>

                <div className="d-flex justify-content-between">
                  <AmountItem label="Totale servizi:" value={formik.values.totalServices} />
                </div>
                {!currentUser.isCustomer && (
                  <>
                    <div className="my-1 text-center" style={{ lineHeight: "1" }}>
                      <hr />
                      {process.env.NODE_ENV != "production" && <small>Rivendita</small>}
                    </div>

                    <div className="d-flex justify-content-between">
                      <AmountItem label="Sconto:" value={-(formik.values.retailTotalDiscount ?? 0)} />
                    </div>

                    <div className="d-flex justify-content-between">
                      <AmountItem label="Totale merce netto:" value={formik.values.retailNet} />
                    </div>

                    <div className="d-flex justify-content-between">
                      <AmountItem label="Costi installazione:" value={formik.values.retailInstallationCosts} />
                    </div>

                    <div className="d-flex justify-content-between">
                      <AmountItem label="Totale imponibile:" value={formik.values.retailTaxableAmount} />
                    </div>

                    <div className="d-flex justify-content-between">
                      <AmountItem label="Totale iva:" value={formik.values.retailTotalTaxes} />
                    </div>

                    <div className="d-flex justify-content-between">
                      <AmountItem label="Totale ordine:" value={formik.values.retailTotal} />
                    </div>
                  </>
                )}
                {currentUser.isCustomer /*&& data.endClientSummary*/ && (
                  <>
                    <div className="my-1 text-center" style={{ lineHeight: "1" }}>
                      <hr />
                      {process.env.NODE_ENV != "production" && <small>Cliente finale</small>}
                    </div>

                    <div className="d-flex justify-content-between">
                      <AmountItem label="Sconto:" value={-(formik.values.endClientTotalDiscount ?? 0)} />
                    </div>

                    <div className="d-flex justify-content-between">
                      <AmountItem label="Totale merce netto:" value={formik.values.endClientNet} />
                    </div>

                    <div className="d-flex justify-content-between">
                      <AmountItem label="Costi installazione:" value={formik.values.retailInstallationCosts} />
                    </div>

                    <div className="d-flex justify-content-between">
                      <AmountItem label="Totale imponibile:" value={formik.values.endClientTaxableAmount} />
                    </div>

                    <div className="d-flex justify-content-between">
                      <AmountItem label="Totale iva:" value={formik.values.endClientTotalTaxes} />
                    </div>

                    <div className="d-flex justify-content-between">
                      <AmountItem label="Totale ordine:" value={formik.values.endClientTotal} />
                    </div>
                  </>
                )}
              </div>
            </div>
            {!loading && 
              <div className="d-flex flex-row-reverse justify-content-between mt-3 px-4">
                <Button disabled={isSubmit} variant="contained" className="ps-3 pe-1" onClick={() => handlingSubmit(formik.values,formik)}>
                  <span>Genera preventivo</span>
                  <NavigateNextIcon />
                </Button>

                <Button variant="contained" className="ps-1 pe-3" color="secondary" onClick={() => navigate(goBack)}>
                  <NavigateBeforeIcon />
                  <span>Indietro</span>
                </Button>
              </div>
            }
            {loading && <Loading />}
        </div>
      </div>
    </div>
    </>
  );
};

export default ConditionsForm;
